// extracted by mini-css-extract-plugin
export default {"employees":"employees_employees__fSR9X","employee":"employees_employee__z-Q5Z","gp":"employees_gp__32o-G","btns":"employees_btns__272h1"};